import * as FilePond from "filepond";
import "filepond/dist/filepond.min.css";
import translations from "./translations.js";
import FilePondPluginFileValidateSize from "filepond-plugin-file-validate-size";
import FilePondPluginFileValidateType from "filepond-plugin-file-validate-type";

FilePond.registerPlugin(FilePondPluginFileValidateSize, FilePondPluginFileValidateType);

const csrfToken = document.querySelector('meta[name="csrf-token"]').getAttribute("content");

window.fileponds = [];

export default function () {
    const configMap = [
        {
            selector: "input.filepond-image",
            acceptedFileTypes: ["image/png", "image/jpg", "image/jpeg"],
        },
        {
            selector: "input.filepond-png-image",
            acceptedFileTypes: ["image/png"],
        },
        {
            selector: "input.filepond-pdf",
            acceptedFileTypes: ["application/pdf"],
        },
    ];

    configMap.forEach(({ selector, acceptedFileTypes }) => {
        document.querySelectorAll(selector).forEach((input) => {
            const instance = FilePond.create(input, {
                credits: false,
                server: {
                    process: "/file/upload",
                    headers: {
                        "X-CSRF-TOKEN": csrfToken,
                    },
                },
                maxFileSize: "10MB",
                acceptedFileTypes,
                ...translations,
            });

            window.fileponds.push(instance);
        });
    });
}
